export default {
  turquise: '#D3E9E2',
  // turquise: '#CAEBF0',
  turquiseBright: '#edf7f3',
  // turquiseBright: '#e8f7fb',
  rose: '#F9E6DD',
  // rose: '#f1dadf',
  // roseBright: '#f8eeec',
  roseBright: '#fef3f0',
  grey: '#686868'
}
